(function() {
  function initVideoBackgroundSimple() {
    const sections = document.querySelectorAll('[data-video-bg-section]');

    sections.forEach(function(section) {
      const video = section.querySelector('.video-bg__video');
      const soundButton = section.querySelector('.video-bg__sound-btn');
      const iconOff = section.querySelector('.video-bg__sound-icon--off');
      const iconOn = section.querySelector('.video-bg__sound-icon--on');

      if (!video || !soundButton || !iconOff || !iconOn) return;

      let isMuted = true;

      function toggleSound() {
        isMuted = !isMuted;
        video.muted = isMuted;
        soundButton.setAttribute('aria-pressed', !isMuted);

        if (isMuted) {
          iconOff.style.display = 'block';
          iconOn.style.display = 'none';
        } else {
          iconOff.style.display = 'none';
          iconOn.style.display = 'block';
        }
      }

      function handleResponsiveVideo() {
        const isMobile = window.innerWidth <= 768;
        const desktopSrc = video.dataset.desktopSrc;
        const mobileSrc = video.dataset.mobileSrc;
        const currentSrc = video.currentSrc;

        if (isMobile && mobileSrc && !currentSrc.includes(mobileSrc)) {
          video.src = mobileSrc;
          video.load();
        } else if (!isMobile && desktopSrc && !currentSrc.includes(desktopSrc)) {
          video.src = desktopSrc;
          video.load();
        }
      }

      soundButton.addEventListener('click', toggleSound);

      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleResponsiveVideo, 250);
      });

      handleResponsiveVideo();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoBackgroundSimple);
  } else {
    initVideoBackgroundSimple();
  }
})();
